import { useEffect, useState } from 'react';
import { isArrayOfObjects } from '@utils';

/**
 * Generic hook to handle the selection of an item within a list.
 * @param data
 * @param propKey the prop to be used to search for an item in the array
 */
const useTabSelector = <T, K extends keyof T>({ data, propKey }: { data?: T[]; propKey: K }) => {
  const [selectedItem, setSelectedItem] = useState<T | undefined>();

  useEffect(() => {
    if (!selectedItem && isArrayOfObjects(data) && data?.length > 0) {
      setSelectedItem(data[0]);
    }
  }, [data, selectedItem]);

  useEffect(() => {
    if (isArrayOfObjects(data) && data?.length > 0) {
      setSelectedItem((prevSelected) =>
        data.find((item) => item[propKey] === prevSelected?.[propKey])
      );
    }
  }, [data, propKey]);

  return { selectedItem, setSelectedItem };
};

export default useTabSelector;
